<div
  [ngClass]="
    isAdjustMargin
      ? 'sm:ml-24 sm:mr-24 md:ml-44 md:mr-44 xl:ml-96 xl:mr-96'
      : ''
  "
>
  <p-carousel
    [value]="imageArr"
    [numVisible]="4"
    [numScroll]="3"
    [circular]="true"
    [responsiveOptions]="responsiveOptions"
    [autoplayInterval]="3000"
    [showIndicators]="false"
    [showNavigators]="false"
  >
    <ng-template let-image pTemplate="item">
      <div
        [ngClass]="
          image.includes('T2P')
            ? 'px-5 pt-5 pb-4 w-24 sm:w-40'
            : isAdjustSize
            ? 'w-36 sm:w-52 '
            : image.includes('central_world') ||
              image.includes('erawan') ||
              image.includes('gaysorn') ||
              image.includes('RSPC')
            ? 'w-32 sm:w-60 sm:h-44'
            : 'w-24 sm:w-40'
        "
        class="h-24 sm:h-40 overflow-hidden m-auto"
      >
        <img
          class="w-full h-full object-contain"
          [src]="image"
          alt="sponsor image"
        />
      </div>
    </ng-template>
  </p-carousel>
</div>
